"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OpenOrdersComponent = _interopRequireDefault(require("./OpenOrdersComponent"));
var _orderHistorySelectors = require("../../../redux/selectors/orderHistorySelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
var _selectors = require("../../../redux/futures/selectors");
var _selectors2 = require("../../../redux/margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps() {
  var openOrdersSelector = (0, _orderHistorySelectors.openOrdersSelectorFactory)();
  return function (state, _ref) {
    var config = _ref.config,
      selectedInstrument = _ref.selectedInstrument;
    var _state$apexCore$order = state.apexCore.orderHistory,
      activeRequests = _state$apexCore$order.activeRequests,
      openOrdersStartIndex = _state$apexCore$order.openOrdersStartIndex;
    var openOrders = openOrdersSelector(state, config);
    var allOpenOrders = (0, _orderHistorySelectors.allOpenOrdersSelector)(state);
    var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
    var fetching = activeRequests > 0;
    var selectedInstrumentId = (0, _instrumentPositionSelectors.selectedInstrumentIdSelector)(state);
    var isFuturesActive = (0, _selectors.isFuturesActiveSelector)(state);
    var isMarginActive = (0, _selectors2.isMarginActiveSelector)(state);
    return {
      data: openOrders,
      allData: allOpenOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument,
      selectedInstrumentId: selectedInstrumentId,
      openOrdersStartIndex: openOrdersStartIndex,
      selectedAccountId: state.user.selectedAccountId,
      OMSId: state.user.userInfo.OMSId,
      isFuturesActive: isFuturesActive,
      isMarginActive: isMarginActive
    };
  };
};
var mapDispatchToProps = {
  getOpenOrders: _orderHistoryActions.getOpenOrders,
  cancelOrders: _orderHistoryActions.cancelOrders,
  resetActivePage: _orderHistoryActions.resetActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_OpenOrdersComponent["default"]);